module.exports = __webpack_public_path__ + "static/media/ManageUserAdmin.7d8960dd.PNG";